import React from "react";
import publicConfig from "../common/public-config";
import { composeDataMethods, getUsrLocale } from "@lululemon/mwa-utils";
import dynamic from "next/dynamic";
const SigninModal = dynamic(() => import( /* webpackChunkName: "SigninModal"*/
"@lululemon/auth-ui").then(mod => mod.SigninModal), {
  ssr: false
});
const withSigninModal = Component => {
  const WithSigninModal = props => {
    var _publicConfig$okta;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SigninModal, {
      locale: props === null || props === void 0 ? void 0 : props.locale,
      oktaConfig: (publicConfig === null || publicConfig === void 0 ? void 0 : (_publicConfig$okta = publicConfig.okta) === null || _publicConfig$okta === void 0 ? void 0 : _publicConfig$okta.config) || (publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.okta)
    }), /*#__PURE__*/React.createElement(Component, props));
  };
  return composeDataMethods(Component, {
    getInitialProps: appContext => {
      var _appContext$ctx;
      let locale = "en_US";
      const req = appContext === null || appContext === void 0 ? void 0 : (_appContext$ctx = appContext.ctx) === null || _appContext$ctx === void 0 ? void 0 : _appContext$ctx.req;
      if (req) {
        locale = getUsrLocale(req);
      } else {
        var _window, _window$__NEXT_DATA__;
        locale = typeof window !== "undefined" ? (_window = window) === null || _window === void 0 ? void 0 : (_window$__NEXT_DATA__ = _window.__NEXT_DATA__) === null || _window$__NEXT_DATA__ === void 0 ? void 0 : _window$__NEXT_DATA__.locale : locale;
      }
      return {
        locale
      };
    }
  })(WithSigninModal);
};
export default withSigninModal;